// User roles — single source of truth, kept in sync with the backend
// (database_api schema.UserType). Prefer these over raw string literals.

export const USER_TYPES = {
  SUPERUSER: 'superuser',
  ADMIN: 'admin',
  MANAGER: 'manager',
  INTEGRATOR: 'integrator',
  DEVICE: 'device',
  BOT: 'bot',
};

// Common role groupings used for UI gating.
export const ADMIN_ROLES = [USER_TYPES.SUPERUSER, USER_TYPES.ADMIN];
export const MANAGEMENT_ROLES = [USER_TYPES.SUPERUSER, USER_TYPES.ADMIN, USER_TYPES.MANAGER];
